<gp-modal #cancelWorkflowPopup
          [closable]="true"
          [size]="'sm'"
          class="cancel-workflow-modal"
          gp-modal="cancel-workflow">
  <div class="gp-modal-title">
    <i class="fa-solid fa-diamond-exclamation text-danger m-r-xs"></i>
    <strong>{{ 'WORKFLOWS.cancel_workflow' | translate }}</strong>
  </div>
  <div class="gp-modal-body clearfix">
    <div *ngIf="cancelWorkflowDetails" class="col-md-12 form-group">
      <div class="m-b-xs">
        <p class="detail-label">{{ 'WORKFLOWS.type' | translate }}</p>
        <p class="detail-value m-b-xs">{{cancelWorkflowDetails.workflowType | translate}}</p>
      </div>
      <div class="workflow-details">
        <div class="m-b-xs">
          <p class="detail-label">{{ 'WORKFLOWS.subject' | translate }}</p>
          <p class="detail-value m-b-xs">{{cancelWorkflowDetails?.workflowSubject}}
            <span *ngIf="cancelWorkflowDetails?.subjectEmployeeNumber"
                  class="text-muted">({{cancelWorkflowDetails?.subjectEmployeeNumber}})
            </span>
          </p>
        </div>
        <div class="m-b-xs">
          <p class="detail-label">{{ 'WORKFLOWS.assignee' | translate }}</p>
          <ng-container *ngIf="cancelWorkflowDetails?.workflowAssignees?.length; else singleAssignee">
            <div class="assignees-grid">
              <p *ngFor="let assignee of cancelWorkflowDetails?.workflowAssignees" class="detail-value m-b-xs assignee-item">
                {{assignee?.fullName}}
              </p>
            </div>
          </ng-container>
          <ng-template #singleAssignee>
            <p class="detail-value m-b-xs">{{cancelWorkflowDetails.workflowAssignee}}
              <span *ngIf="cancelWorkflowDetails?.assigneeEmployeeNumber"
                    class="text-muted">({{cancelWorkflowDetails?.assigneeEmployeeNumber}})
              </span></p>
          </ng-template>
        </div>
        <div class="m-b-xs">
          <p class="detail-label">{{ 'WORKFLOWS.status' | translate }}</p>
          <gp-workflow-status [status]="cancelWorkflowDetails.workflowStatus"></gp-workflow-status>
        </div>
        <div>
          <p class="detail-label">{{ 'COMMON.comment' | translate }}</p>
          <textarea
            [formControl]="comment"
            [rows]="5" class="textarea-control">
        </textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="gp-modal-footer">

    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="cancelWorkflow(cancelWorkflowPopup)"
                class="btn btn-danger p-x-md"
                type="button">
          {{ 'FORMS.confirm' | translate }}
        </button>
        <button (click)="cancelWorkflowPopup.close()"
                class="btn btn-secondary p-x-md"
                type="button">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>
